import styled from "styled-components";

export const RegenerateSecretsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
